<section class="row no-gutters d-flex justify-content-center">
  <div
    *ngIf="accessories?.length === 0"
    class="app-bg-light app-text-neutral rounded text-center px-3 py-2 w-100">
    No Accessories Set.
  </div>
  <div class="d-flex justify-content-around w-100 mx-4">
    <div
      *ngFor="let accessory of accessories; let i = index"
      class="d-flex align-items-center flex-column mt-3 mx-3"
    >
      <app-accessory-item
        [accessory]="accessory"
        [itemIndex]="i"
        iconMode="true"
        [selectedDealAccessory]="selectedDealAccessory(accessory, selectedAccessories)"
        [itemIndex]="i"
        [inCart]="accessoryInCart(accessory) && isPaintAccessoryEnabled(accessory,selectedAccessories)"
      ></app-accessory-item>
    </div>
  </div>
</section>